import io from "socket.io-client";
import { useMemo, createContext, useContext } from "react";

const SocketContext = createContext(null);

export function useSocket() {
  return useContext(SocketContext);
}

export default function SocketProvider({ children }) {
  const socket = useMemo(
    () =>
      io.connect(process.env.REACT_APP_SERVER_URL),
    []
  );
  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
}
